import { Modal } from 'bootstrap.native';
/* eslint-disable-next-line */
import { event, loader } from '../../Foundation';
/* eslint-disable-next-line */
import throttle from 'lodash.throttle';
import { AmendPrices } from './components/amend-prices';
import domready from 'domready';
import { NumberInput } from '../../Feature';

export class CartLine {
  /**
   * Creates a new instance of the Video class for handling HTML5 Video, Youtube Videos and 23Videos
   * @param {HTMLElement} element Video DOM element
   */
  constructor(element) {
    // Name, reference
    element.CartLine = this;
    this.el = element;

    // Data
    this._data = JSON.parse(element.dataset.cartline);

    // Props
    this._props = {
      isFavorite: this.el.classList.contains('is-favorite'),
    };

    // Elements
    this._refs = {
      el: element,
      numberInput: element.querySelector('.number-input'),
      accessoriesNumberInputs: element.getElementsByClassName('accessories-number-input'),
      flexpoints: element.querySelector('.cart-line__flex-points'),
      editButton: element.querySelector('.is-editable'),
      configuratorSide: element.querySelector('.configurator__selector__side'),
      buttons: {
        delete: element.querySelector('.js-cartline-remove'),
        amendPrice: element.querySelector('.change-price'),
      },
      dialogs: {
        delete: element.querySelector('.js-cartline-remove-dialog'),
        quantity: element.querySelector('.js-cartline-quantity-update-dialog'),
        quantityError: element.querySelector('.js-cartline-quantity-error-dialog'),
      },
      config: {
        links: Array.from(element.querySelectorAll('.cart-line__controls-start a')),
        contentarea: element.querySelector('.cart-line__configuration'),
      },
      table: {
        columns: Array.from(element.querySelectorAll('td.hover')),
      },
    };

    this._refs.editButton?.addEventListener('click', this._onItemClick.bind(this));

    // Load
    if (
      this._refs.config.contentarea.classList.contains('is-active') &&
      this._refs.config.show != null &&
      this._refs.config.hide != null
    ) {
      this._refs.config.show.classList.add('is-hidden');
      this._refs.config.hide.classList.remove('is-hidden');
    }

    // Toggle configuration
    if (this._refs.buttons.delete != null && !element.classList.contains('constructorFinished')) {
      this._refs.buttons.delete.addEventListener('click', this._onRemoveItemClick.bind(this));
    }

    // Number input
    if (this._refs.numberInput != null && !element.classList.contains('constructorFinished')) {
      this._refs.numberInput.addEventListener(
        'numberinput.updated',
        this._onNumberinputUpdate.bind(this),
      );
    }

    // Accessories number input
    if (this._refs.accessoriesNumberInputs.length > 0) {
      for (var i = 0; i < this._refs.accessoriesNumberInputs.length; i++) {
        var accessoryNumberInput = this._refs.accessoriesNumberInputs[i];
        accessoryNumberInput.addEventListener(
          'accessoriesnumberinput.updated',
          this._onAccessoriesNumberInputUpdate.bind(this, accessoryNumberInput),
        );
        var accessoryCartLineId = accessoryNumberInput.querySelector(
          '#AccessoryLineIdHiddenField',
        ).value;
        var accessoryItemNo = accessoryNumberInput.querySelector(
          '#AccessoryItemNoHiddenField',
        ).value;
        new NumberInput(accessoryNumberInput, true, accessoryCartLineId, accessoryItemNo);
      }
    }

    if (this._refs.buttons.amendPrice != null) {
      this._refs.buttons.amendPrice.addEventListener(
        'click',
        this._onAmendPriceLinkClick.bind(this),
      );
    }

    // Checking if page has loaded
    if (this._refs.buttons.amendPrice != null) {
      if (document.readyState === 'complete') {
        this._refs.buttons.amendPrice.classList.remove('disableClick');
      } else {
        this._refs.buttons.amendPrice.classList.add('disableClick');
        domready(() => {
          this._refs.buttons.amendPrice.classList.remove('disableClick');
        });
      }
    }

    this._addLoaderForRemoveAccessories();
    this.hideEmptyModelText();

    element.classList.add('constructorFinished');
  }

  /**
   * Calculator for flexpoints in case a flexpoint-item has been added as cartLine
   * @param {Event} detail - Details from updated number-input
   */
  /* eslint-disable-next-line */
  _onNumberInputUpdate({ detail }) {}

  _addLoaderForRemoveAccessories() {
    const accessoriesBinIcons = document.querySelectorAll('.remove-accessory');

    accessoriesBinIcons.forEach((accessoriesBinIcon) => {
      accessoriesBinIcon.addEventListener('click', () => loader.show(), { once: true });
    });
  }

  /**
   * onItemClick
   * When a user clicks an editable field inside product-table
   * @param {Event} e - event interface
   */
  /* eslint-disable-next-line */
  _onItemClick(e) {
    const currentPropertyIdHiddenField = document.getElementById('CurrentPropertyIdHiddenField'),
      /* eslint-disable-next-line */
      selectedPropertyIdHiddenField = document.getElementById('SelectedPropertyIdHiddenField'),
      //propertyIdHiddenField = e.target.closest('td').querySelector('#PropertyIdHiddenField'),
      selectedEditLineIdHiddenField = document.getElementById('SelectedEditLineIdHiddenField'),
      lineIdHiddenField = this._refs.el.querySelector('#LineIdHiddenField'),
      isEditClickedHiddenField = document.getElementById('IsEditClickedHiddenField');

    currentPropertyIdHiddenField.value = selectedEditLineIdHiddenField.value;
    //selectedPropertyIdHiddenField.value = propertyIdHiddenField.value;

    selectedEditLineIdHiddenField.value = lineIdHiddenField.value;
    isEditClickedHiddenField.value = 'true';

    loader.show();

    __doPostBack('OverviewUpdatePanel', '');
  }

  /**
   * _onRemoveItemClick
   * Remove an item from cart
   * @param {Event} e - event interface
   */
  _onRemoveItemClick(e) {
    e.preventDefault();

    let id = this._refs.buttons.delete.dataset.target,
      el = this.el.querySelector(id),
      modal = el.Modal || new Modal(el),
      handler = () => {
        modal.hide();

        let lineId = this.el.querySelector('#LineIdHiddenField');
        if (lineId != null) {
          let oLineId = document.getElementById('SelectedDeleteLineIdHiddenField');
          if (oLineId != null) {
            oLineId.value = lineId.value;
          }
        }

        const calendarFields = document.querySelectorAll('[data-datepicker]');
        const calendarFieldsAsElements = [...calendarFields];

        calendarFieldsAsElements.forEach((cf) => {
          cf.disabled = true;
        });

        // Execute postback
        __doPostBack(this._data.RemoveCartItemLinkButtonId, '');
      };

    // Display
    modal.show();

    // Events
    if (el) {
      el.addEventListener(
        'shown.bs.modal',
        (event) => {
          let x = event.target,
            trigger = x.querySelector('.btn-primary');

          trigger.addEventListener('click', handler);
        },
        false,
      );

      el.addEventListener(
        'hide.bs.modal',
        (event) => {
          let x = event.target,
            trigger = x.querySelector('.btn-primary');

          trigger.removeEventListener('click', handler);
        },
        false,
      );
    }
  }

  /**
   * _onConfigurationToggle
   * @param {Event} e - Event Interface
   */
  _onConfigurationToggle(e) {
    let target = e.target;

    e.preventDefault();

    if (target.classList.contains('js-hide-configurator')) {
      this._refs.config.show.classList.remove('is-hidden');

      this._refs.config.contentarea.classList.remove('is-active');

      this._refs.config.hide.classList.add('is-hidden');
    } else {
      this._refs.config.show.classList.add('is-hidden');

      this._refs.config.contentarea.classList.add('is-active');

      this._refs.config.hide.classList.remove('is-hidden');
    }
  }

  /**
   * _onNumberinputUpdate
   * Update quantity for cartLine once user has changed input
   * @param {HTMLEvent} e - event interface
   */
  _onNumberinputUpdate({ detail }) {
    const updateFavoritesApi = '/api/favorites/updatequantity';
    const updateCartlineApi = '/api/cart/cartline/updatequantity';
    const quantity = detail.value,
      lineId = this.el.querySelector('#LineIdHiddenField'),
      api = this._props.isFavorite ? updateFavoritesApi : updateCartlineApi;

    // Flexpoints calculation
    if (this._refs.flexpoints !== null) {
      // Flexpoint calculation
      const oItemUnitValue = parseInt(this._refs.flexpoints.dataset.point),
        oItemPointCalculation = this._refs.flexpoints.querySelector('div');

      if (oItemUnitValue === null || oItemPointCalculation === null) return;

      oItemPointCalculation.innerHTML = (oItemUnitValue * detail.value).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      });
    }
    loader.show();
    fetch(api, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        Id: lineId.value,
        Quantity: quantity,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          var oldValue = this.el.getAttribute('oldvalue') ?? detail.initial;
          //var currentCartTotalItemsCount = +document.querySelector('.main-navigation__basket>span').innerHTML;

          //if (detail.value != oldValue)
          //currentCartTotalItemsCount = currentCartTotalItemsCount - oldValue + detail.value;

          //this._setNewTotalCartItemsCount(currentCartTotalItemsCount);
          this.el.setAttribute('oldvalue', detail.value);

          // Send to google analytics
          if (oldValue != detail.value) {
            var numberChange = Math.abs(detail.value - oldValue);
            var gaEventName = oldValue > detail.value ? 'remove_from_cart' : 'add_to_cart';
            var productNumber = this.el.querySelector('.product_number').innerText;
            var productName = this.el.querySelector('.product-item__modelText').innerText;

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
              event: gaEventName,
              ecommerce: {
                currency: 'EUR',
                items: [
                  {
                    item_id: productNumber,
                    item_name: productName,
                    item_category: 'n/a',
                    item_category2: 'n/a',
                    item_category3: 'n/a',
                    item_category4: 'n/a',
                    price: 1.0,
                    quantity: numberChange,
                  },
                ],
              },
            });

            response.json().then((body) => {
              const cartData = JSON.parse(body);
              if (cartData !== undefined) {
                if (api === updateCartlineApi) {
                  this.syncReceiversAmount(cartData);
                }
                cartData.forEach((product) => {
                  cartItems.push({
                    item_id: product.ProductId,
                    item_name: product.ModelName,
                    item_brand: product.Brand,
                    item_category: product.PricePoint,
                    item_category2: product.FamilyCode,
                    item_category3: product.ShellType,
                    item_category4: product.Color,
                    item_variant: product.ModelNumber,
                    price: 1,
                    quantity: product.Quantity,
                  });
                });
                dataLayer.push({
                  event: 'cart_state',
                  ecommerce: {
                    currency: 'EUR',
                    items: cartItems,
                  },
                });

                this._updatePackagingText(lineId.value, productNumber, cartData);
                this._pushDataLayerCartState(cartData);
              }
            });
          }
        }
        // Minimum display time for the loader
        setTimeout(() => loader.hide(), 250);
        /* eslint-disable-next-line */
      })
      .catch((response) => {
        console.log(response);
        loader.hide();
      });
  }

  _updatePackagingText(lineId, productNumber, cartData) {
    const tableEl = this._refs.el.querySelector('.productDetailTable');
    const rowsEl = tableEl?.getElementsByTagName('tr') ?? [];

    for (let i = 0; i < rowsEl.length; i++) {
      const inputsEl = [...rowsEl[i].getElementsByTagName('input')];
      const packagingInput = !!inputsEl.find((inputEl) => inputEl.value === 'Packaging');

      if (packagingInput) {
        const rowLiElements = rowsEl[i].getElementsByTagName('li');
        const cartDataItem = cartData.find(
          (d) => d.LineId === lineId && productNumber.includes(d.ProductId),
        );

        if (rowLiElements.length && cartDataItem) {
          rowLiElements[0].textContent = cartDataItem.Packaging;
        }
        break;
      }
    }
  }

  _pushDataLayerCartState(cartData) {
    const cartItems = [];

    cartData.forEach((product) => {
      cartItems.push({
        item_id: product.ProductId,
        item_name: product.ModelName,
        item_brand: product.Brand,
        item_category: product.PricePoint,
        item_category2: product.FamilyCode,
        item_category3: product.ShellType,
        item_category4: product.Color,
        item_variant: product.ModelNumber,
        price: 1,
        quantity: product.Quantity,
      });
    });

    dataLayer.push({
      event: 'cart_state',
      ecommerce: {
        currency: 'EUR',
        items: cartItems,
      },
    });
  }

  /**
   * syncReceiversAmount
   * Synchronization receivers amount on the UI based on the response from the backend once user has changed quantity
   * @param {HTMLEvent} cartData - cart data from the API call
   */
  syncReceiversAmount(cartData) {
    const productIds = cartData.map((d) => d.ProductId);
    const receiverNumberSpans = [...this.el.querySelectorAll('span.product_number')];
    receiverNumberSpans.forEach((span) => {
      if (!productIds.includes(span.innerText)) {
        const liElement = span.closest('li');
        if (liElement) {
          liElement.remove();
        }
      }
    });
  }

  /**
   * __onAccessoriesNumberInputUpdate
   * Update quantity for accessories cartLine once user has changed input
   * @param {HTMLEvent} e - event interface
   */
  _onAccessoriesNumberInputUpdate(accessoryNumberInputElement, e) {
    const quantity = e.detail.value,
      lineId = accessoryNumberInputElement.querySelector('#AccessoryLineIdHiddenField'),
      itemNo = accessoryNumberInputElement.querySelector('#AccessoryItemNoHiddenField'),
      api = this._props.isFavorite
        ? '/api/favorites/updatequantity'
        : '/api/cart/accessorycartline/updatequantity';

    // Flexpoints calculation
    if (this._refs.flexpoints !== null) {
      // Flexpoint calculation
      const oItemUnitValue = parseInt(this._refs.flexpoints.dataset.point),
        oItemPointCalculation = this._refs.flexpoints.querySelector('div');

      if (oItemUnitValue === null || oItemPointCalculation === null) return;

      oItemPointCalculation.innerHTML = (oItemUnitValue * detail.value).toLocaleString('en-US', {
        maximumFractionDigits: 2,
      });
    }

    loader.show();
    fetch(api, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        Id: lineId.value,
        Quantity: quantity,
        ItemNo: itemNo.value,
      }),
    })
      .then((response) => {
        if (response.status === 200) {
          var oldValue = accessoryNumberInputElement.getAttribute('oldvalue') ?? e.detail.initial;
          var currentCartTotalItemsCount = +document.querySelector('.main-navigation__basket>span')
            .innerHTML;

          if (e.srcElement.classList.contains('accessories-number-input')) {
            if (e.detail.value != oldValue)
              currentCartTotalItemsCount = currentCartTotalItemsCount - oldValue + e.detail.value;
          }

          this._setNewTotalCartItemsCount(currentCartTotalItemsCount);
          accessoryNumberInputElement.setAttribute('oldvalue', e.detail.value);
        }
        // Minimum display time for the loader
        setTimeout(() => loader.hide(), 250);
        /* eslint-disable-next-line */
      })
      .catch((response) => {
        console.log(response);
        loader.hide();
      });
  }
  /**
   * _onChangePriceItemClick
   * Method for abort the amend prices flow
   * @param {Event} e - event interface
   */
  _onAmendPriceLinkClick(e) {
    e.preventDefault();

    let id = this._refs.buttons.amendPrice.dataset.target,
      el = this.el.querySelector(id),
      modal = el.Modal || new Modal(el);

    // Display
    modal.show();

    /* eslint-disable-next-line */
    const oAmendPrices = new AmendPrices(el);
  }

  removeOrderTypeRadioButton() {
    const stockQuantity = document.querySelector('.cart-line__quantity');
    document.querySelector('.cart-line__delivery-date .form-group')?.appendChild(stockQuantity);
    let radioButtons = document.getElementsByClassName('RadiobuttonSelection');
    [...radioButtons].forEach((radio) => {
      if (!radio.firstChild.getAttribute('checked')) {
        radio.remove();
      }
    });
  }

  appendProductQuantity() {
    [...document.querySelectorAll('.cart-line:not(.is-favorite)')].forEach((cartLine) => {
      let quantity = cartLine.querySelector('.cart-line__quantity');
      let quantityTable = cartLine.querySelector('.cart-line__quantity table');
      if (quantity) {
        cartLine.querySelector('.cart-line__delivery-date .form-group')?.appendChild(quantity);
        if (quantityTable) {
          quantityTable.classList.add('is-hidden');
        }
      }
    });
  }

  getConfiguratorSideText() {
    [...document.querySelectorAll('.cart-line')].forEach((cartLineSection) => {
      const sideValue = cartLineSection.querySelector('.configurator__selector__side label');
      let orderTypeText = cartLineSection.querySelector(
        '.productDetailTable .RadiobuttonSelection label',
      );
      if (sideValue !== null) {
        orderTypeText.innerHTML += `, ${sideValue.textContent}`;
      }
    });
  }

  addMarginBusinessWrapperDescription() {
    if (document.querySelector('.top-free-text') !== null) {
      document.querySelector('.top-free-text').classList.add('col-md-10');
      document.querySelector('.top-free-text').classList.add('cart-top-free-text');
    }
  }

  //_setNewTotalCartItemsCount(newTotalCartItemsCount) {
  //    const topMainTitle = document.querySelector('.top-main-title').textContent.substring(0, document.querySelector('.top-main-title').textContent.indexOf('('));

  //    document.querySelector('.main-navigation__basket>span').innerHTML = newTotalCartItemsCount;
  //    document.querySelector('.products-counter').innerHTML = newTotalCartItemsCount;
  //    document.getElementById('cssCart')?.setAttribute('cart-title-overwrite-counter', newTotalCartItemsCount);
  //    document.querySelector('.top-main-title').textContent = `${topMainTitle} (${newTotalCartItemsCount} ${parseInt(newTotalCartItemsCount) > 1 ? document.getElementById('cssCart')?.getAttribute('cart-title-overwrite-text-plural') : document.getElementById('cssCart')?.getAttribute('cart-title-overwrite-text-singular')})`
  //}

  adjustProductColorRow() {
    [...document.querySelectorAll('.configurator__controller-color')].forEach((colorDivNode) => {
      if (colorDivNode.nextSibling?.textContent.trim() === '') {
        colorDivNode.nextSibling.remove();
      }

      let parentNode = colorDivNode.parentNode;
      let colorText = parentNode.querySelector('span');
      colorText.classList.add('capitalize-letters');

      if (parentNode) {
        parentNode.insertBefore(colorText, colorDivNode);
      }
    });
  }

  adjustEarmoldTitleStyling() {
    [...document.querySelectorAll('.product-item__familyCode')].forEach((productCode) => {
      if (productCode.textContent === '') {
        productCode.parentNode.classList.add('hide-dots');
      }
    });
  }

  adjustAccessoriesTitleStyling() {
    [...document.querySelectorAll('.product-item__familyCode')].forEach((productCode) => {
      if (productCode.textContent === '') {
        const productItemName = productCode.parentNode;
        productItemName.previousElementSibling.style.display = 'none';

        const accessoryNameElement = productItemName.nextElementSibling;

        if (!accessoryNameElement) return;

        const headingContainer = productItemName.parentNode;
        const cartLineHeadStart = headingContainer.parentNode;
        const accessoryName = accessoryNameElement.textContent;

        let PKUNumber = document.createElement('p');
        let accessoryDetails = document.createElement('span');
        accessoryDetails.textContent = cartLineHeadStart
          .querySelector('h3.cart-line__sku > span')
          ?.textContent.split('- ')[1];
        accessoryDetails.classList.add('product_number');
        headingContainer.classList.add('product-details-line-height');
        PKUNumber.textContent = accessoryName.split('- ')[0];
        PKUNumber.style.fontSize = '1.2rem';
        PKUNumber.style.marginBottom = '2px';
        if (!/^\d/.test(PKUNumber.textContent)) PKUNumber.style.fontSize = '2rem';
        const splitAccesoryArray = accessoryName.split('- ');
        const accesoryText = splitAccesoryArray[splitAccesoryArray.length - 1] || accessoryName;
        accessoryNameElement.textContent = accesoryText;
        if (productCode.nextElementSibling.innerText === '') {
          headingContainer.appendChild(PKUNumber);
          headingContainer.appendChild(accessoryDetails);
        }
      }
    });
  }

  hideEmptyModelText() {
    [...document.querySelectorAll('.product-item__modelText')].forEach((modelText) => {
      if (modelText.textContent === '' && modelText.previousElementSibling.textContent !== '') {
        modelText.parentNode.removeChild(modelText);
      }
    });
  }

  addEarmoldSideToTitle() {
    [...document.querySelectorAll('h3.cart-line__sku > span')].forEach((productInfo) => {
      if (productInfo.textContent !== '') {
        const side = productInfo.textContent.split(' - ', 1)[0];
        const productDetails = productInfo.parentNode.nextElementSibling;
        if (!/^\d/.test(side))
          productDetails.lastElementChild.innerText = `${side}, ${productDetails.lastElementChild.innerText}`;
      }
    });
  }

  updateDeleteButtonAlignment() {
    [...document.querySelectorAll('.cart-line__configuration')].forEach((removeIcon, index) => {
      removeIcon?.appendChild([...document.querySelectorAll('.js-cartline-remove')][index]);
    });
  }
}
